<template>
  <div class="nav" :style="navStyle">
    <div
      :style="containerStyle"
      :class="['nav-container', pin && 'nav-pin']"
      ref="navContainer">

      <div class="nav-bg-container" :style="{backgroundImage: `url(${bgContainerBg})`, height: navHeight}">
        <nav-group class="nav-group" v-bind="groupInfo"/>
      </div>
    </div>
  </div>
</template>

<script>
import {calcRem750} from "@/pages/Campaign/utils/calcRem"
import NavGroup from "@/pages/Campaign/components/NavGroup"
import {imgUrl} from "@/pages/Campaign/utils/img"
import {mapState} from "vuex";

export default {
  name: "NavBlock",
  components: {
    NavGroup
  },
  props: {
    info: {
      poi: Number,
      styleType: String,
      baseBg: Object,
      pinBg: Object,
      placeholderBg: Object,
      group: Object
    },
    // 是否固定在顶部
    pin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['anchor']),
    bgContainerBg() {
      // 目前一级选中的标签可能会切换背景
      const firstLevelItemId = this.anchor.find(e => e.level === 1)?.id || -1
      const item = this.info.group.items.find(e => e.id === firstLevelItemId)

      return imgUrl(item?.bgSelect ? item?.bgSelect : this.info.baseBg)
    },
    groupInfo() {
      const group = this.info.group
      return {
        styleType: this.info.styleType,
        ...group
      }
    },
    navHeight() {
      return calcRem750(this.info.baseBg.height)
    },
    navStyle() {
      return {
        backgroundImage: `url(${imgUrl(this.info.placeholderBg)})`,
        height: this.navHeight,
        minHeight: this.navHeight,
        margin: '-1px 0'
      }
    },
    containerStyle() {
      return {
        backgroundImage: this.pin ? `url(${imgUrl(this.info.pinBg)})` : null,
        height: this.navHeight,
        minHeight: this.navHeight
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav,
.nav-container,
.nav-bg-container {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.nav-pin {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
}
</style>
